import PagedList from 'models/accessors/pagedList';
import loanApplicationService from '../../../accessors/loanApplicationService';
import LoanApplication from '../../../models/loan/loanApplication';
import { AppThunk } from '../../../redux/store/store';
import { PAGED_LOAN_APPLICATIONS, LOAN_APPLICATION_DETAILS, LOAN_ADD_DOCUMENT, LOAN_DELETE_DOCUMENT, LOAN_OPENREQUESTS, ID_DOCUMENTS_UPLOADED } from '../../store/loan/types';
import { TOGGLE_API_REQUEST_SUCCESS, TOGGLE_LOADING, TOGGLE_MODAL_LOADING } from '../../store/system/types';
import LoanDocument from 'models/loanDocument/loanDocument';
import AddDocumentsRequest from 'models/addDocumentsRequest/AddDocumentsRequest';
import DocumentRequest from 'models/documentData/DocumentRequest';
import LoanApplicationFilterCriteria from 'models/accessors/LoanApplicationFilterCriteria'
import IdDocumentUpload from 'models/account/customer/idDocumentUpload/idDocumentUpload';

export const getLoanApplications = (
    filterCriteria: LoanApplicationFilterCriteria
): AppThunk => async (dispatch) => {
    loanApplicationService.GetLoanApplications(filterCriteria)
        .then((pagedList: PagedList<LoanApplication>) => {
            dispatch({
                type: PAGED_LOAN_APPLICATIONS,
                payload: {
                    pagedLoanApplications: pagedList
                },
            });

            dispatch({
                type: TOGGLE_LOADING,
                payload: { isLoading: false }
            });
        })
};

export const getLoanApplicationDetails = (id: number): AppThunk => async (dispatch) => {
    loanApplicationService.GetLoanApplicationDetails(id)
        .then((loan: LoanApplication) => {
            dispatch({
                type: TOGGLE_LOADING,
                payload: { isLoading: false }
            });

            dispatch(findOpenDocumentRequests(loan.customerAccount.id));

            dispatch({
                type: LOAN_APPLICATION_DETAILS,
                payload: {
                    loanApplicationDetails: loan
                },
            });
        })
};

export const addLoanDocument = (
    loanDocuments: AddDocumentsRequest
): AppThunk => async (dispatch) => {
    loanApplicationService.AddLoanDocument(loanDocuments)
        .then((newDocuments: LoanDocument[]) => {
            dispatch({
                type: TOGGLE_MODAL_LOADING,
                payload: { isModalLoading: false }
            });
            // We are returning a blank object if there was an error
            if (newDocuments.length > 0) {
                dispatch({
                    type: LOAN_ADD_DOCUMENT,
                    payload: {
                        loanDocuments: newDocuments
                    },
                });

                dispatch({
                    type: TOGGLE_API_REQUEST_SUCCESS,
                    payload: {
                        apiRequestSuccess: true
                    },
                });
            }
        })
};

export const deleteLoanDocument = (
    loanDocumentId: number
): AppThunk => async (dispatch) => {
    loanApplicationService.DeleteLoanDocument(loanDocumentId)
        .then((success: boolean) => {
            dispatch({
                type: TOGGLE_MODAL_LOADING,
                payload: { isModalLoading: false }
            });

            // We are returning a blank object if there was an error
            if (success) {
                dispatch({
                    type: LOAN_DELETE_DOCUMENT,
                    payload: {
                        loanDocumentId: loanDocumentId
                    },
                });

                dispatch({
                    type: TOGGLE_API_REQUEST_SUCCESS,
                    payload: {
                        apiRequestSuccess: true
                    },
                });
            }
        })
};

export const findOpenDocumentRequests = (
    customerAccountId: number
): AppThunk => async (dispatch) => {
    loanApplicationService.FindOpenDocumentRequests(customerAccountId)
        .then((data: DocumentRequest[]) => {
            if (data) {
                dispatch({
                    type: LOAN_OPENREQUESTS,
                    payload: {
                        openDocumentRequests: data
                    },
                });

                dispatch({
                    type: TOGGLE_API_REQUEST_SUCCESS,
                    payload: {
                        apiRequestSuccess: true
                    },
                });
            }
        })
};

export const uploadIdDocument = (
    idDocumentUpload: IdDocumentUpload
): AppThunk => async (dispatch) => {
    loanApplicationService.AddIdDocument(idDocumentUpload)
        .then(customerDocuments => {
            dispatch({
                type: TOGGLE_MODAL_LOADING,
                payload: { isModalLoading: false }
            });
            // We are returning a blank object if there was an error
            if (Object.keys(customerDocuments).length > 0) {
                dispatch({
                    type: ID_DOCUMENTS_UPLOADED,
                    payload: {
                        customerDocuments: customerDocuments
                    },
                });

                dispatch({
                    type: TOGGLE_API_REQUEST_SUCCESS,
                    payload: {
                        apiRequestSuccess: true
                    },
                });
            }
        })
};